
import { useEffect, useState } from "react";
import { CaretUpFilled, DeleteOutlined, FileDoneOutlined, HolderOutlined, MinusOutlined, MoreOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, DatePicker, Flex, Input, Popover } from "antd"
import DraggableItem from "./DraggableItem.jsx";
import { v4 as uuidv4 } from "uuid";
import DurationBlock from "./DurationBlock.jsx";
import SprintRow from "./SprintRow.jsx";
import { useTranslation } from 'react-i18next';


const Sprint = (props) => {
    const { t } = useTranslation();
    const { sprintDetail, addSprintDuration, estimationData, updateEstimation } = props
    const [sprints, setSprints] = useState([])

    useEffect(() => {
        if (estimationData.sprints) {
            setSprints(estimationData.sprints)
        }
    }, [estimationData.sprints])

    const addSprint = () => {
        let updatedSprints = [...sprints, { uuid: uuidv4(), title: "", start: '1', end: '2', subLevels: [] }]
        updateEstimation("sprints", updatedSprints)
    }

    const handleLabelChange = (subId, sprintId, value) => {
        let updatedData = [...sprints];
        updatedData = updatedData.map(sprint => {
            if (sprint.uuid === sprintId) {
                if (subId) {
                    sprint.subLevels = sprint.subLevels.map(sub => {
                        if (sub.uuid === subId) {
                            return { ...sub, title: value }
                        }
                        return { ...sub }
                    })
                } else {
                    sprint.title = value
                }
            }
            return { ...sprint }
        })
        updateEstimation("sprints", updatedData)

    }

    const removeSubLevel = (subId, sprintId) => {
        let updatedData = [...sprints];
        updatedData = updatedData.map(sprint => {
            if (sprint.uuid === sprintId) {
                sprint.subLevels = sprint.subLevels.filter(sub => sub.uuid !== subId)
            }
            return { ...sprint }
        })
        updateEstimation("sprints", updatedData)
    }

    const addSubLevel = (sprintId) => {
        let updatedData = [...sprints];
        let reqSprint = updatedData.find(sprint => sprint.uuid === sprintId)
        reqSprint.subLevels.push({ uuid: uuidv4(), title: '', start: reqSprint.start, end: reqSprint.end, color: reqSprint.color || "#0A99FE"})
        updateEstimation("sprints", updatedData)

    }

    const copySprint = (sprint) => {
        let updatedSprints = [...sprints, { ...sprint, uuid: uuidv4(), title: sprint.title + " Copy" }]
        updateEstimation("sprints", updatedSprints)

    }

    const deleteSprint = (sprint) => {
        let updatedSprints = sprints.filter(data => data.uuid !== sprint.uuid)
        updateEstimation("sprints", updatedSprints)

    }

    const updateSprintDuration = (id, newStart, newEnd, parentId) => {
        let updatedSprints = sprints.map(sprint => {
            if (parentId && parentId === sprint.uuid) {
                sprint.subLevels = sprint.subLevels.map(level => {
                    if (level.uuid === id) {
                        return { ...level, start: newStart, end: newEnd }
                    } else {
                        return { ...level }
                    }
                })
                let maxParentEnd = Math.max(...sprint.subLevels.map(o => o.end))
                let minParentStart = Math.min(...sprint.subLevels.map(o => o.start))
                sprint.start = minParentStart
                sprint.end = maxParentEnd
                if (newEnd > maxParentEnd) {
                }
                if (newStart < minParentStart) {
                }
                return { ...sprint }
            } else {
                if (sprint.uuid === id) {
                    return { ...sprint, start: newStart, end: newEnd }
                } else {
                    return { ...sprint }
                }
            }
        })
        // setSprints(updatedSprints)
        updateEstimation("sprints", updatedSprints)

    }

    const updateSprintColor = (sprintId, color) => {
        let updatedSprints = sprints.map(sprint => {
            if(sprint.uuid === sprintId) {
                sprint.subLevels.forEach(sublevel => {
                    sublevel.color = color
                })
                return {...sprint, color: color}
            }  else {
                return {...sprint}
            }
        })
        // setSprints(updatedSprints)
        updateEstimation("sprints", updatedSprints)

    }

    return (
        <>
            <Flex justify="space-between" align="center" style={{ padding: "0.75rem 2.5rem" }}>
                <div className="text-" style={{ color: "#000" }}>{t('Sprints')}</div>
                <Flex gap={16}>
                    <DatePicker placeholder={t('Planned start date')} />
                    <Button icon={<PlusOutlined />}>{t('Add Section')}</Button>
                </Flex>
            </Flex>
            <div className="sprint-container" style={{ minHeight: sprints.length === 0 ? "23rem" : "fit-content" }}>
            <div className="sprint-header-row">
                    <div className="sprint-left-section">
                        <div className="add-sprint" style={{ justifyContent: "space-between", padding: "0 1rem 0 2.5rem" }}>
                            <span><Button className="submit-button" size="small" icon={<PlusOutlined />} style={{ marginRight: "8px" }} onClick={addSprint} />{t('Add Sprint')}</span>
                            
                        </div>

                    </div>

                    <div className="sprint-right-section">
                        <div className="empty-block">{sprintDetail.timeline} </div>
                        <Flex>
                            {
                                [...Array(sprintDetail.duration)].map((e, i) => {
                                    return <div className="week-block" key={i} >
                                        <div className="week-cell" style={{ borderLeft: i === 0 ? "0px solid" : "1px solid #C7C8F3" }}>
                                            {Number(i + 1)} { i+1 === sprintDetail.duration && sprintDetail.duration > 15 && <MinusOutlined style={{ marginLeft: "5px", fontSize: "14px"}} onClick={() => addSprintDuration(-1)} /> }
                                        </div>
                                    </div>
                                })
                            }
                            <div className="week-block" style={{ flexGrow: "1", maxWidth: "none" }}>
                                    <div className="week-cell" style={{ justifyContent: "flex-start", paddingLeft: "1rem", borderLeft: "1px solid #C7C8F3" }}>
                                        <PlusOutlined style={{ color: "var(-theme-color-primary)" }} onClick={() => addSprintDuration(1)} />
                                    </div>
                                </div>
                        </Flex>
                    </div>
                </div>
                {
                    sprints.map((sprint, sprintIndex) => {
                        return (
                            <SprintRow sprints={sprints} sprintDetail={sprintDetail} sprint={sprint} addSubLevel={addSubLevel} removeSubLevel={removeSubLevel} handleLabelChange={handleLabelChange} copySprint={copySprint} deleteSprint={deleteSprint} updateSprintDuration={updateSprintDuration} updateSprintColor={updateSprintColor} />

                        )
                    })
                }
                {/* <div className="sprint-row">
                    <div className="sprint-left-section">
                        <div className="add-sprint"><Button className="submit-button" size="small" icon={<PlusOutlined />} onClick={addSprint} />Add Sprint</div>
                        <Flex gap={16} vertical style={{ borderRight: "1px solid #C7C8F3",padding: "16px 0px"}}>
                        {
                            sprints.map((sprint, sprintIndex) => {
                                return (
                                    <SprintRow sprint={sprint} addSubLevel={addSubLevel} removeSubLevel={removeSubLevel} handleLabelChange={handleLabelChange} copySprint={copySprint} deleteSprint={deleteSprint} />
                                )
                            })
                        }
                        </Flex>
                    </div>

                    <div className="sprint-right-section">
                        <div className="empty-block">{sprintDetail.timeline} </div>
                        <Flex>
                            {
                                [...Array(sprintDetail.duration)].map((e, i) => {
                                    return <div className="week-block" key={i} >
                                        <div className="week-cell" style={{ borderLeft: i === 0 ? "0px solid" : "1px solid #C7C8F3" }}>
                                            {Number(i + 1)}
                                        </div>
                                    </div>
                                })
                            }

                            <div className="week-block" style={{ flexGrow: "1", maxWidth: "none" }}>
                                <div className="week-cell" style={{ justifyContent: "flex-start", paddingLeft: "1rem", borderLeft: "1px solid #C7C8F3" }}>
                                    <PlusOutlined style={{ color: "var(-theme-color-primary)" }} onClick={addSprintDuration} />
                                </div>
                            </div>
                        </Flex>

                    </div>
                </div> */}
            </div >

        </>
    )
}

export default Sprint